import { render, staticRenderFns } from "./removeWarehouseDetail.vue?vue&type=template&id=5bbea736&scoped=true&"
import script from "./removeWarehouseDetail.vue?vue&type=script&lang=js&"
export * from "./removeWarehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./removeWarehouseDetail.vue?vue&type=style&index=0&id=5bbea736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbea736",
  null
  
)

export default component.exports